export default class ProtocolosService{

	constructor($http, baseUrl){
		this.http    = $http;
		this.baseUrl = baseUrl;

		this.routes = {
			"all": '/api/protocolos',
			"id": '/api/protocolos/:id',
			"new": '/api/protocolos',
            "update": '/api/protocolos',
			'delete': '/api/protocolos/:id'
		};
	}

	getAll(filter){
		let url = this.baseUrl + this.routes.all;
		let config = {
			params : filter
		};
		return this.http.get(url, config);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

	delete(objId){
		let idRoute = this.routes.delete.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.delete(url);
	}

    update(data){
        let url = this.baseUrl + this.routes.update;
        return this.http.put(url, data);
    }
}



// WEBPACK FOOTER //
// ./app/js/services/protocolosService.js